var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mx-3 md:mx-10 my-8"},[_c('transition-page',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }